
// import React, { useState, useRef, useEffect } from "react";
// import { db } from "../firebase/firebase";
// import { collection, addDoc, query, where, getDocs } from "firebase/firestore";
// import config from "../config/app.js";

// export default function AIAssistant() {
//   const [isOpen, setIsOpen] = useState(false);
//   const [hasNewMessage, setHasNewMessage] = useState(false);

//   const [messages, setMessages] = useState([
//     { role: "model", text: "Zdravo! Ja sam ManieraAI. Kako mogu da ti pomognem danas?" }
//   ]);
//   const [input, setInput] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [awaitingUserInfo, setAwaitingUserInfo] = useState(false);
//   const [pendingBooking, setPendingBooking] = useState(null);
//   const [lastMessageTime, setLastMessageTime] = useState(0);

//   const chatEndRef = useRef(null);

//   useEffect(() => {
//     if (isOpen) {
//       chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
//       setHasNewMessage(false);
//     }
//   }, [messages, isOpen]);

//   const addMessage = (role, text) => {
//     setMessages(prev => [...prev, { role, text }]);
//     if (role === "model" && !isOpen) {
//       setHasNewMessage(true);
//     }
//   };

//   const askAI = async (userText) => {
//     try {
//       const res = await fetch(`${config.apiUrl}/api/chat`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ message: userText })
//       });
//       const data = await res.json();
//       return data.reply || "Nemam odgovor 😕";
//     } catch (err) {
//       console.error("Frontend AI error:", err);
//       return "Nemam odgovor 😕";
//     }
//   };

//   const detectBookingIntent = (text) => {
//     const t = text.toLowerCase();
//     return t.includes("termin") || t.includes("zakazi") || t.includes("rezervacija");
//   };

//   const extractDate = (text) => {
//     const regex = /\b(danas|sutra|\d{4}-\d{2}-\d{2})\b/;
//     const match = text.match(regex);
//     if (!match) return null;
//     if (match[0] === "danas") return new Date().toISOString().split("T")[0];
//     if (match[0] === "sutra") {
//       const d = new Date();
//       d.setDate(d.getDate() + 1);
//       return d.toISOString().split("T")[0];
//     }
//     return match[0];
//   };

//   const parseFullBooking = (text) => {
//     const t = text.toLowerCase();
//     let service = null;
//     if (t.includes("klasic")) service = "Classic Cut";
//     if (t.includes("fade")) service = "Fade";
//     if (t.includes("taper")) service = "Taper";
//     if (t.includes("brad")) service = "Beard Trim";

//     const date = extractDate(t);
//     const timeMatch = t.match(/(\d{1,2})[: ](\d{2})/);
//     const time = timeMatch ? `${timeMatch[1].padStart(2, "0")}:${timeMatch[2]}` : null;
//     const phoneMatch = t.match(/06\d+/);
//     const phone = phoneMatch ? phoneMatch[0] : null;
//     const nameMatch = text.match(/,\s*([A-Za-zČčĆćŠšŽžĐđ]+)/);
//     const name = nameMatch ? nameMatch[1] : null;

//     if (service && date && time && name && phone) {
//       return { service, date, time, name, phone };
//     }
//     return null;
//   };

//   const findNextAvailableSlot = async (date) => {
//     const hours = Array.from({ length: 10 }, (_, i) => i + 9);
//     const minutes = ["00", "15", "30", "45"];
//     const snap = await getDocs(query(collection(db, "appointments"), where("date", "==", date)));
//     const booked = snap.docs.map(doc => doc.data().time);
//     for (let h of hours) {
//       for (let m of minutes) {
//         const time = `${h < 10 ? "0" + h : h}:${m}`;
//         if (!booked.includes(time)) return time;
//       }
//     }
//     return null;
//   };

//   const handleSend = async () => {
//     if (!input.trim() || loading) return;
//     const now = Date.now();
//     if (now - lastMessageTime < 1500) {
//       addMessage("model", "Molim te sačekaj trenutak pre nove poruke.");
//       return;
//     }
//     setLastMessageTime(now);
//     addMessage("user", input);
//     const userText = input;
//     setInput("");
//     setLoading(true);

//     try {
//       // 1. Pokušaj puni booking u jednoj poruci
//       const fullBooking = parseFullBooking(userText);
//       if (fullBooking) {
//         const snap = await getDocs(query(collection(db, "appointments"), where("date", "==", fullBooking.date)));
//         const booked = snap.docs.map(doc => doc.data().time);
//         if (booked.includes(fullBooking.time)) {
//           addMessage("model", "Nažalost taj termin je zauzet.");
//         } else {
//           await addDoc(collection(db, "appointments"), {
//             date: fullBooking.date,
//             time: fullBooking.time,
//             name: fullBooking.name,
//             phone: fullBooking.phone,
//             haircut: fullBooking.service
//           });
//           addMessage("model", `Dobar dan ${fullBooking.name}! Potvrđujem Vaš termin ${fullBooking.date} u ${fullBooking.time} za ${fullBooking.service}.`);
//         }
//         setLoading(false);
//         return;
//       }

//       // 2. Korisnik šalje podatke za pending booking
//       if (awaitingUserInfo && pendingBooking) {
//         const parts = userText.split(",");
//         if (parts.length < 3) {
//           addMessage("model", "Pošalji ime, broj i tip frizure: Ime, 06xxxx, Classic Cut/Fade/Taper/Beard Trim");
//           setLoading(false);
//           return;
//         }
//         const [name, phone, haircut] = parts.map(p => p.trim());
//         if (!name || !phone || !haircut) {
//           addMessage("model", "Nevalidan unos. Pošalji: Ime, 06xxxx, tip frizure");
//           setLoading(false);
//           return;
//         }
//         await addDoc(collection(db, "appointments"), {
//           date: pendingBooking.date,
//           time: pendingBooking.time,
//           name,
//           phone,
//           haircut
//         });
//         addMessage("model", `✅ Rezervisano! Termin ${pendingBooking.date} u ${pendingBooking.time} za ${haircut} je tvoj.`);
//         setPendingBooking(null);
//         setAwaitingUserInfo(false);
//         setLoading(false);
//         return;
//       }

//       // 3. Booking intent bez punih podataka
//       const wantsBooking = detectBookingIntent(userText);
//       const date = extractDate(userText);

//       if (wantsBooking || date) {
//         const slot = await findNextAvailableSlot(date);
//         if (!slot) {
//           addMessage("model", `Nažalost nema slobodnih termina za ${date}.`);
//         } else {
//           addMessage("model", `Prvi slobodan termin za ${date} je u ${slot}. Da li želiš da ga rezervišem? Pošalji ime, broj i tip frizure: Ime, 06xxxx, Classic Cut/Fade/Taper/Beard Trim`);
//           setPendingBooking({ date, time: slot });
//           setAwaitingUserInfo(true);
//         }
//         setLoading(false);
//         return;
//       }

//       // 4. Tek ovde ide AI — troši tokene samo za opšta pitanja
//       const reply = await askAI(userText);
//       addMessage("model", reply);

//     } catch (err) {
//       console.error(err);
//       addMessage("model", "Greška u obradi poruke.");
//     }

//     setLoading(false);
//   };

//   return (
//     <>
//       <div style={{
//         ...styles.container,
//         opacity: isOpen ? 1 : 0,
//         pointerEvents: isOpen ? "all" : "none",
//         transform: isOpen ? "translateY(0) scale(1)" : "translateY(20px) scale(0.95)",
//         transition: "all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1)"
//       }}>
//         <div style={styles.header}>
//           <span>✨ ManieraAI</span>
//           <button onClick={() => setIsOpen(false)} style={styles.closeBtn}>✕</button>
//         </div>

//         <div style={styles.chatWindow}>
//           {messages.map((msg, i) => (
//             <div key={i} style={{ ...styles.msgRow, justifyContent: msg.role === "user" ? "flex-end" : "flex-start" }}>
//               <div style={{
//                 ...styles.bubble,
//                 backgroundColor: msg.role === "user" ? "#bca24c" : "#f0f0f0",
//                 color: msg.role === "user" ? "#fff" : "#333",
//                 borderRadius: msg.role === "user" ? "18px 18px 4px 18px" : "18px 18px 18px 4px"
//               }}>
//                 {msg.text}
//               </div>
//             </div>
//           ))}
//           {loading && (
//             <div style={styles.loader}>
//               <span style={styles.dot} />
//               <span style={{ ...styles.dot, animationDelay: "0.2s" }} />
//               <span style={{ ...styles.dot, animationDelay: "0.4s" }} />
//             </div>
//           )}
//           <div ref={chatEndRef} />
//         </div>

//         <div style={styles.inputArea}>
//           <input
//             style={styles.input}
//             value={input}
//             onChange={e => setInput(e.target.value)}
//             onKeyDown={e => e.key === "Enter" && handleSend()}
//             placeholder="Pitaj me nešto..."
//           />
//           <button onClick={handleSend} style={styles.sendBtn} disabled={loading}>➤</button>
//         </div>
//       </div>

//       <button
//         onClick={() => { setIsOpen(prev => !prev); setHasNewMessage(false); }}
//         style={styles.toggleBtn}
//       >
//         {isOpen ? "✕" : "✨"}
//         {hasNewMessage && !isOpen && <span style={styles.badge} />}
//       </button>

//       <style>{`
//         @keyframes bounce {
//           0%, 80%, 100% { transform: translateY(0); }
//           40% { transform: translateY(-6px); }
//         }
//         @keyframes pulse {
//           0%, 100% { transform: scale(1); }
//           50% { transform: scale(1.15); }
//         }
//       `}</style>
//     </>
//   );
// }

// const styles = {
//   container: { position: "fixed", bottom: "80px", right: "20px", width: "min(320px, calc(100vw - 40px))", height: "min(450px, calc(100vh - 120px))", background: "#fff", borderRadius: "16px", boxShadow: "0 8px 32px rgba(0,0,0,0.18)", display: "flex", flexDirection: "column", zIndex: 1000, overflow: "hidden" },
//   header: { padding: "14px 16px", background: "#1e1e1e", color: "#bca24c", fontWeight: "bold", fontSize: "0.95rem", display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 },
//   closeBtn: { background: "none", border: "none", color: "#bca24c", cursor: "pointer", fontSize: "1rem", padding: "2px 6px", borderRadius: "4px", lineHeight: 1 },
//   chatWindow: { flex: 1, padding: "12px", overflowY: "auto", display: "flex", flexDirection: "column", gap: "8px" },
//   msgRow: { display: "flex" },
//   bubble: { maxWidth: "80%", padding: "9px 13px", fontSize: "0.85rem", lineHeight: "1.45" },
//   inputArea: { padding: "10px 12px", display: "flex", gap: "8px", borderTop: "1px solid #eee", flexShrink: 0 },
//   input: { flex: 1, padding: "9px 14px", borderRadius: "20px", border: "1px solid #ddd", outline: "none", fontSize: "0.85rem", minWidth: 0 },
//   sendBtn: { background: "#bca24c", border: "none", color: "#fff", cursor: "pointer", fontSize: "1rem", width: "36px", height: "36px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
//   loader: { display: "flex", gap: "4px", padding: "4px 8px", alignItems: "center" },
//   dot: { width: "7px", height: "7px", borderRadius: "50%", background: "#bca24c", display: "inline-block", animation: "bounce 1.2s infinite ease-in-out" },
//   toggleBtn: { position: "fixed", bottom: "20px", right: "20px", width: "52px", height: "52px", borderRadius: "50%", background: "#bca24c", border: "none", color: "#fff", fontSize: "1.4rem", cursor: "pointer", boxShadow: "0 4px 16px rgba(188,162,76,0.45)", zIndex: 1001, display: "flex", alignItems: "center", justifyContent: "center", animation: "pulse 3s infinite ease-in-out" },
//   badge: { position: "absolute", top: "4px", right: "4px", width: "10px", height: "10px", borderRadius: "50%", background: "#e74c3c", border: "2px solid #fff" }
// };











// import React, { useState, useRef, useEffect } from "react";
// import { db } from "../firebase/firebase";
// import { collection, addDoc, query, where, getDocs } from "firebase/firestore";
// import config from "../config/app.js";

// export default function AIAssistant() {
//   const [isOpen, setIsOpen] = useState(false);
//   const [hasNewMessage, setHasNewMessage] = useState(false);

//   const [messages, setMessages] = useState([
//     { role: "model", text: "Hello! I'm ManieraAI. How can I help you today?" }
//   ]);
//   const [input, setInput] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [awaitingUserInfo, setAwaitingUserInfo] = useState(false);
//   const [pendingBooking, setPendingBooking] = useState(null);
//   const [lastMessageTime, setLastMessageTime] = useState(0);

//   const chatEndRef = useRef(null);

//   useEffect(() => {
//     if (isOpen) {
//       chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
//       setHasNewMessage(false);
//     }
//   }, [messages, isOpen]);

//   const addMessage = (role, text) => {
//     setMessages(prev => [...prev, { role, text }]);
//     if (role === "model" && !isOpen) {
//       setHasNewMessage(true);
//     }
//   };

//   const askAI = async (userText) => {
//     try {
//       const res = await fetch(`${config.apiUrl}/api/chat`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ message: userText })
//       });
//       const data = await res.json();
//       return data.reply || "I don't have an answer for that 😕";
//     } catch (err) {
//       console.error("Frontend AI error:", err);
//       return "I don't have an answer for that 😕";
//     }
//   };

//   const detectBookingIntent = (text) => {
//     const t = text.toLowerCase();
//     return t.includes("appointment") || t.includes("book") || t.includes("reservation") || t.includes("schedule");
//   };

//   const extractDate = (text) => {
//     const regex = /\b(today|tomorrow|\d{4}-\d{2}-\d{2})\b/;
//     const match = text.match(regex);
//     if (!match) return null;
//     if (match[0] === "today") return new Date().toISOString().split("T")[0];
//     if (match[0] === "tomorrow") {
//       const d = new Date();
//       d.setDate(d.getDate() + 1);
//       return d.toISOString().split("T")[0];
//     }
//     return match[0];
//   };

//   const parseFullBooking = (text) => {
//     const t = text.toLowerCase();
//     let service = null;
//     if (t.includes("classic")) service = "Classic Cut";
//     if (t.includes("fade")) service = "Fade";
//     if (t.includes("taper")) service = "Taper";
//     if (t.includes("beard")) service = "Beard Trim";

//     const date = extractDate(t);
//     const timeMatch = t.match(/(\d{1,2})[: ](\d{2})/);
//     const time = timeMatch ? `${timeMatch[1].padStart(2, "0")}:${timeMatch[2]}` : null;
//     const phoneMatch = t.match(/06\d+/);
//     const phone = phoneMatch ? phoneMatch[0] : null;
//     const nameMatch = text.match(/,\s*([A-Za-zČčĆćŠšŽžĐđ]+)/);
//     const name = nameMatch ? nameMatch[1] : null;

//     if (service && date && time && name && phone) {
//       return { service, date, time, name, phone };
//     }
//     return null;
//   };

//   const findNextAvailableSlot = async (date) => {
//     const hours = Array.from({ length: 10 }, (_, i) => i + 9);
//     const minutes = ["00", "15", "30", "45"];
//     const snap = await getDocs(query(collection(db, "appointments"), where("date", "==", date)));
//     const booked = snap.docs.map(doc => doc.data().time);
//     for (let h of hours) {
//       for (let m of minutes) {
//         const time = `${h < 10 ? "0" + h : h}:${m}`;
//         if (!booked.includes(time)) return time;
//       }
//     }
//     return null;
//   };

//   const handleSend = async () => {
//     if (!input.trim() || loading) return;
//     const now = Date.now();
//     if (now - lastMessageTime < 1500) {
//       addMessage("model", "Please wait a moment before sending another message.");
//       return;
//     }
//     setLastMessageTime(now);
//     addMessage("user", input);
//     const userText = input;
//     setInput("");
//     setLoading(true);

//     try {
//       // 1. Try full booking in one message
//       const fullBooking = parseFullBooking(userText);
//       if (fullBooking) {
//         const snap = await getDocs(query(collection(db, "appointments"), where("date", "==", fullBooking.date)));
//         const booked = snap.docs.map(doc => doc.data().time);
//         if (booked.includes(fullBooking.time)) {
//           addMessage("model", "Unfortunately that appointment slot is already taken.");
//         } else {
//           await addDoc(collection(db, "appointments"), {
//             date: fullBooking.date,
//             time: fullBooking.time,
//             name: fullBooking.name,
//             phone: fullBooking.phone,
//             haircut: fullBooking.service
//           });
//           addMessage("model", `Hello ${fullBooking.name}! Your appointment on ${fullBooking.date} at ${fullBooking.time} for ${fullBooking.service} is confirmed.`);
//         }
//         setLoading(false);
//         return;
//       }

//       // 2. User sends info for pending booking
//       if (awaitingUserInfo && pendingBooking) {
//         const parts = userText.split(",");
//         if (parts.length < 3) {
//           addMessage("model", "Please send your name, phone number, and haircut type: Name, 06xxxx, Classic Cut/Fade/Taper/Beard Trim");
//           setLoading(false);
//           return;
//         }
//         const [name, phone, haircut] = parts.map(p => p.trim());
//         if (!name || !phone || !haircut) {
//           addMessage("model", "Invalid input. Please send: Name, 06xxxx, haircut type");
//           setLoading(false);
//           return;
//         }
//         await addDoc(collection(db, "appointments"), {
//           date: pendingBooking.date,
//           time: pendingBooking.time,
//           name,
//           phone,
//           haircut
//         });
//         addMessage("model", `✅ Booked! The appointment on ${pendingBooking.date} at ${pendingBooking.time} for ${haircut} is yours.`);
//         setPendingBooking(null);
//         setAwaitingUserInfo(false);
//         setLoading(false);
//         return;
//       }

//       // 3. Booking intent without full details
//       const wantsBooking = detectBookingIntent(userText);
//       const date = extractDate(userText);

//       if (wantsBooking || date) {
//         const slot = await findNextAvailableSlot(date);
//         if (!slot) {
//           addMessage("model", `Unfortunately there are no available slots for ${date}.`);
//         } else {
//           addMessage("model", `The first available slot for ${date} is at ${slot}. Would you like me to book it? Please send your name, phone number, and haircut type: Name, 06xxxx, Classic Cut/Fade/Taper/Beard Trim`);
//           setPendingBooking({ date, time: slot });
//           setAwaitingUserInfo(true);
//         }
//         setLoading(false);
//         return;
//       }

//       // 4. AI fallback — only for general questions
//       const reply = await askAI(userText);
//       addMessage("model", reply);

//     } catch (err) {
//       console.error(err);
//       addMessage("model", "An error occurred while processing your message.");
//     }

//     setLoading(false);
//   };

//   return (
//     <>
//       <div style={{
//         ...styles.container,
//         opacity: isOpen ? 1 : 0,
//         pointerEvents: isOpen ? "all" : "none",
//         transform: isOpen ? "translateY(0) scale(1)" : "translateY(20px) scale(0.95)",
//         transition: "all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1)"
//       }}>
//         <div style={styles.header}>
//           <span>✨ ManieraAI</span>
//           <button onClick={() => setIsOpen(false)} style={styles.closeBtn}>✕</button>
//         </div>

//         <div style={styles.chatWindow}>
//           {messages.map((msg, i) => (
//             <div key={i} style={{ ...styles.msgRow, justifyContent: msg.role === "user" ? "flex-end" : "flex-start" }}>
//               <div style={{
//                 ...styles.bubble,
//                 backgroundColor: msg.role === "user" ? "#bca24c" : "#f0f0f0",
//                 color: msg.role === "user" ? "#fff" : "#333",
//                 borderRadius: msg.role === "user" ? "18px 18px 4px 18px" : "18px 18px 18px 4px"
//               }}>
//                 {msg.text}
//               </div>
//             </div>
//           ))}
//           {loading && (
//             <div style={styles.loader}>
//               <span style={styles.dot} />
//               <span style={{ ...styles.dot, animationDelay: "0.2s" }} />
//               <span style={{ ...styles.dot, animationDelay: "0.4s" }} />
//             </div>
//           )}
//           <div ref={chatEndRef} />
//         </div>

//         <div style={styles.inputArea}>
//           <input
//             style={styles.input}
//             value={input}
//             onChange={e => setInput(e.target.value)}
//             onKeyDown={e => e.key === "Enter" && handleSend()}
//             placeholder="Ask me something..."
//           />
//           <button onClick={handleSend} style={styles.sendBtn} disabled={loading}>➤</button>
//         </div>
//       </div>

//       <button
//         onClick={() => { setIsOpen(prev => !prev); setHasNewMessage(false); }}
//         style={styles.toggleBtn}
//       >
//         {isOpen ? "✕" : "✨"}
//         {hasNewMessage && !isOpen && <span style={styles.badge} />}
//       </button>

//       <style>{`
//         @keyframes bounce {
//           0%, 80%, 100% { transform: translateY(0); }
//           40% { transform: translateY(-6px); }
//         }
//         @keyframes pulse {
//           0%, 100% { transform: scale(1); }
//           50% { transform: scale(1.15); }
//         }
//       `}</style>
//     </>
//   );
// }

// const styles = {
//   container: { position: "fixed", bottom: "80px", right: "20px", width: "min(320px, calc(100vw - 40px))", height: "min(450px, calc(100vh - 120px))", background: "#fff", borderRadius: "16px", boxShadow: "0 8px 32px rgba(0,0,0,0.18)", display: "flex", flexDirection: "column", zIndex: 1000, overflow: "hidden" },
//   header: { padding: "14px 16px", background: "#1e1e1e", color: "#bca24c", fontWeight: "bold", fontSize: "0.95rem", display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 },
//   closeBtn: { background: "none", border: "none", color: "#bca24c", cursor: "pointer", fontSize: "1rem", padding: "2px 6px", borderRadius: "4px", lineHeight: 1 },
//   chatWindow: { flex: 1, padding: "12px", overflowY: "auto", display: "flex", flexDirection: "column", gap: "8px" },
//   msgRow: { display: "flex" },
//   bubble: { maxWidth: "80%", padding: "9px 13px", fontSize: "0.85rem", lineHeight: "1.45" },
//   inputArea: { padding: "10px 12px", display: "flex", gap: "8px", borderTop: "1px solid #eee", flexShrink: 0 },
//   input: { flex: 1, padding: "9px 14px", borderRadius: "20px", border: "1px solid #ddd", outline: "none", fontSize: "0.85rem", minWidth: 0 },
//   sendBtn: { background: "#bca24c", border: "none", color: "#fff", cursor: "pointer", fontSize: "1rem", width: "36px", height: "36px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
//   loader: { display: "flex", gap: "4px", padding: "4px 8px", alignItems: "center" },
//   dot: { width: "7px", height: "7px", borderRadius: "50%", background: "#bca24c", display: "inline-block", animation: "bounce 1.2s infinite ease-in-out" },
//   toggleBtn: { position: "fixed", bottom: "20px", right: "20px", width: "52px", height: "52px", borderRadius: "50%", background: "#bca24c", border: "none", color: "#fff", fontSize: "1.4rem", cursor: "pointer", boxShadow: "0 4px 16px rgba(188,162,76,0.45)", zIndex: 1001, display: "flex", alignItems: "center", justifyContent: "center", animation: "pulse 3s infinite ease-in-out" },
//   badge: { position: "absolute", top: "4px", right: "4px", width: "10px", height: "10px", borderRadius: "50%", background: "#e74c3c", border: "2px solid #fff" }
// };






















// import React, { useState, useRef, useEffect } from "react";
// import { db } from "../firebase/firebase";
// import { collection, addDoc, query, where, getDocs } from "firebase/firestore";
// import config from "../config/app.js";

// // ─── helpers ────────────────────────────────────────────────────────────────

// const formatDate = (isoDate) => {
//   if (!isoDate) return isoDate;
//   const today = getTodayLocal();
//   const tmrw = (() => {
//     const d = new Date();
//     d.setDate(d.getDate() + 1);
//     return d.toLocaleDateString("en-CA", { timeZone: "Europe/Belgrade" });
//   })();
//   if (isoDate === today) return "today";
//   if (isoDate === tmrw) return "tomorrow";
//   const [, m, d] = isoDate.split("-");
//   return `${d}.${m}.`;
// };

// const getTodayLocal = () =>
//   new Date().toLocaleDateString("en-CA", { timeZone: "Europe/Belgrade" });

// const extractDate = (text) => {
//   const t = text.toLowerCase();
//   if (t.includes("now") || t.includes("today"))
//     return getTodayLocal();
//   if (t.includes("tomorrow")) {
//     const d = new Date();
//     d.setDate(d.getDate() + 1);
//     return d.toLocaleDateString("en-CA", { timeZone: "Europe/Belgrade" });
//   }
//   const match = t.match(/\b(\d{4}-\d{2}-\d{2})\b/);
//   return match ? match[0] : null;
// };

// const SERVICE_MAP = {
//   classic: "Classic Cut",
//   fade: "Fade",
//   taper: "Taper",
//   beard: "Beard Trim",
// };

// const extractService = (text) => {
//   const t = text.toLowerCase();
//   for (const [key, val] of Object.entries(SERVICE_MAP)) {
//     if (t.includes(key)) return val;
//   }
//   return null;
// };

// // Flexible parser — accepts "Name, phone, service" or "Name phone service" (with/without commas)
// const parseUserInfoLine = (text) => {
//   // Try comma-separated first
//   const parts = text.split(",").map(p => p.trim()).filter(Boolean);
//   if (parts.length >= 3) {
//     const [name, phone, ...rest] = parts;
//     const haircut = extractService(rest.join(" ")) || rest.join(" ").trim();
//     if (name && phone && haircut) return { name, phone, haircut };
//   }

//   // Fallback: space-separated — phone is the token that starts with 06
//   const tokens = text.trim().split(/\s+/);
//   const phoneIdx = tokens.findIndex(t => /^06\d{6,8}$/.test(t));
//   if (phoneIdx === -1) return null;
//   const phone = tokens[phoneIdx];
//   const service = extractService(text);
//   // Name: everything before the phone token
//   const nameParts = tokens.slice(0, phoneIdx);
//   const name = nameParts.join(" ").replace(/,/g, "").trim();
//   if (name && phone && service) return { name, phone, haircut: service };
//   return null;
// };

// // Full one-shot booking: must have service + date + time + name + phone
// const parseFullBooking = (text) => {
//   const service = extractService(text);
//   const date = extractDate(text);
//   const timeMatch = text.toLowerCase().match(/\b(\d{1,2})[: ](\d{2})\b/);
//   const time = timeMatch ? `${timeMatch[1].padStart(2, "0")}:${timeMatch[2]}` : null;
//   const phoneMatch = text.match(/\b(06\d{6,8})\b/);
//   const phone = phoneMatch ? phoneMatch[0] : null;

//   // Name: first sequence of letters not matching a keyword
//   const nameMatch = text.match(/(?:^|[,\s])([A-Za-zČčĆćŠšŽžĐđ](?:[A-Za-zČčĆćŠšŽžĐđ\s-]{1,30})?)(?=[,\s]|$)/);
//   const name = nameMatch
//     ? nameMatch[1].trim().replace(/\b(fade|taper|beard|classic|cut|sutra|today|tomorrow)\b/gi, "").trim()
//     : null;

//   if (service && date && time && phone && name && name.length >= 2) {
//     return { service, date, time, name, phone };
//   }
//   return null;
// };

// // Booking intent: keyword OR "want haircut/cut" pattern
// const detectBookingIntent = (text) => {
//   const t = text.toLowerCase();
//   const hasKeyword =
//     t.includes("appointment") || t.includes("apointment") ||
//     t.includes("book") || t.includes("rezerv") ||
//     t.includes("reservation") || t.includes("schedule") || t.includes("zakazi");
//   const wantsHaircut =
//     (t.includes("want") || t.includes("need") || t.includes("id like")) &&
//     (t.includes("haircut") || t.includes("cut") || t.includes("fade") ||
//      t.includes("taper") || t.includes("beard"));
//   return hasKeyword || wantsHaircut;
// };

// const findNextAvailableSlot = async (date) => {
//   const hours = Array.from({ length: 10 }, (_, i) => i + 9);
//   const minutes = ["00", "15", "30", "45"];
//   const snap = await getDocs(query(collection(db, "appointments"), where("date", "==", date)));
//   const booked = snap.docs.map(doc => doc.data().time);
//   for (let h of hours) {
//     for (let m of minutes) {
//       const time = `${String(h).padStart(2, "0")}:${m}`;
//       if (!booked.includes(time)) return time;
//     }
//   }
//   return null;
// };

// // ─── component ──────────────────────────────────────────────────────────────

// export default function AIAssistant() {
//   const [isOpen, setIsOpen] = useState(false);
//   const [hasNewMessage, setHasNewMessage] = useState(false);
//   const [messages, setMessages] = useState([
//     { role: "model", text: "Hello! I'm ManieraAI. How can I help you today?" }
//   ]);
//   const [input, setInput] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [awaitingUserInfo, setAwaitingUserInfo] = useState(false);
//   const [awaitingDate, setAwaitingDate] = useState(false);
//   const [pendingBooking, setPendingBooking] = useState(null);
//   const [lastMessageTime, setLastMessageTime] = useState(0);

//   const chatEndRef = useRef(null);

//   useEffect(() => {
//     if (isOpen) {
//       chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
//       setHasNewMessage(false);
//     }
//   }, [messages, isOpen]);

//   const addMessage = (role, text) => {
//     setMessages(prev => [...prev, { role, text }]);
//     if (role === "model" && !isOpen) setHasNewMessage(true);
//   };

//   const askAI = async (userText) => {
//     try {
//       const res = await fetch(`${config.apiUrl}/api/chat`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ message: userText })
//       });
//       const data = await res.json();
//       return data.reply || "I don't have an answer for that 😕";
//     } catch (err) {
//       console.error("Frontend AI error:", err);
//       return "I don't have an answer for that 😕";
//     }
//   };

//   const handleSend = async () => {
//     if (!input.trim() || loading) return;

//     const now = Date.now();
//     if (now - lastMessageTime < 1500) {
//       addMessage("model", "Please wait a moment before sending another message.");
//       return;
//     }
//     setLastMessageTime(now);

//     const userText = input.trim();
//     addMessage("user", userText);
//     setInput("");
//     setLoading(true);

//     try {
//       // 1. Full one-shot booking
//       const fullBooking = parseFullBooking(userText);
//       if (fullBooking) {
//         const snap = await getDocs(
//           query(collection(db, "appointments"), where("date", "==", fullBooking.date))
//         );
//         const booked = snap.docs.map(doc => doc.data().time);
//         if (booked.includes(fullBooking.time)) {
//           addMessage("model", `Unfortunately that slot (${fullBooking.time} on ${formatDate(fullBooking.date)}) is already taken. Would you like me to find the next available time?`);
//         } else {
//           await addDoc(collection(db, "appointments"), {
//             date: fullBooking.date,
//             time: fullBooking.time,
//             name: fullBooking.name,
//             phone: fullBooking.phone,
//             haircut: fullBooking.service
//           });
//           addMessage("model", `✅ Done, ${fullBooking.name}! Your ${fullBooking.service} is booked for ${formatDate(fullBooking.date)} at ${fullBooking.time}. See you then!`);
//         }
//         return;
//       }

//       // 2. User responds with info for a pending booking
//       if (awaitingUserInfo && pendingBooking) {
//         const parsed = parseUserInfoLine(userText);
//         if (!parsed) {
//           addMessage("model", "Couldn't read that — please send your details as: Name, 06xxxxxxxx, haircut (Classic Cut / Fade / Taper / Beard Trim)");
//           return;
//         }
//         try {
//           await addDoc(collection(db, "appointments"), {
//             date: pendingBooking.date,
//             time: pendingBooking.time,
//             name: parsed.name,
//             phone: parsed.phone,
//             haircut: parsed.haircut
//           });
//           addMessage("model", `✅ Booked! ${parsed.name}, your ${parsed.haircut} is confirmed for ${formatDate(pendingBooking.date)} at ${pendingBooking.time}.`);
//           setPendingBooking(null);
//           setAwaitingUserInfo(false);
//         } catch (firestoreErr) {
//           console.error("Firestore error:", firestoreErr);
//           addMessage("model", "Something went wrong saving your booking. Please try again.");
//         }
//         return;
//       }

//       // 3. Booking intent detected
//       if (detectBookingIntent(userText) || awaitingDate) {
//         const date = extractDate(userText);

//         // No date yet — ask for it
//         if (!date) {
//           addMessage("model", "Sure! What day works for you? You can say today, tomorrow, or a date like 2026-06-20.");
//           setAwaitingDate(true);
//           return;
//         }

//         setAwaitingDate(false);

//         // Use requested time if provided, otherwise find next available
//         const requestedTimeMatch = userText.match(/\b(\d{1,2})[: ](\d{2})\b/);
//         const requestedTime = requestedTimeMatch
//           ? `${requestedTimeMatch[1].padStart(2, "0")}:${requestedTimeMatch[2]}`
//           : null;

//         if (requestedTime) {
//           const snap = await getDocs(
//             query(collection(db, "appointments"), where("date", "==", date))
//           );
//           const booked = snap.docs.map(doc => doc.data().time);
//           if (booked.includes(requestedTime)) {
//             const slot = await findNextAvailableSlot(date);
//             if (!slot) {
//               addMessage("model", `${requestedTime} is taken and there are no other slots on ${formatDate(date)}. Try another day?`);
//             } else {
//               addMessage("model", `Sorry, ${requestedTime} is already taken. The next available slot on ${formatDate(date)} is at ${slot}. To confirm: Name, 06xxxxxxxx, haircut (Classic Cut / Fade / Taper / Beard Trim)`);
//               setPendingBooking({ date, time: slot });
//               setAwaitingUserInfo(true);
//             }
//           } else {
//             addMessage("model", `${requestedTime} on ${formatDate(date)} is available! To confirm: Name, 06xxxxxxxx, haircut (Classic Cut / Fade / Taper / Beard Trim)`);
//             setPendingBooking({ date, time: requestedTime });
//             setAwaitingUserInfo(true);
//           }
//         } else {
//           const slot = await findNextAvailableSlot(date);
//           if (!slot) {
//             addMessage("model", `No available slots on ${formatDate(date)}, sorry! Would you like to try another day?`);
//           } else {
//             addMessage("model", `The first open slot on ${formatDate(date)} is at ${slot}. To confirm: Name, 06xxxxxxxx, haircut (Classic Cut / Fade / Taper / Beard Trim)`);
//             setPendingBooking({ date, time: slot });
//             setAwaitingUserInfo(true);
//           }
//         }
//         return;
//       }

//       // 4. AI fallback — general barbershop questions
//       const reply = await askAI(userText);
//       addMessage("model", reply);

//     } catch (err) {
//       console.error(err);
//       addMessage("model", "An error occurred while processing your message.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <div style={{
//         ...styles.container,
//         opacity: isOpen ? 1 : 0,
//         pointerEvents: isOpen ? "all" : "none",
//         transform: isOpen ? "translateY(0) scale(1)" : "translateY(20px) scale(0.95)",
//         transition: "all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1)"
//       }}>
//         <div style={styles.header}>
//           <span>✨ ManieraAI</span>
//           <button onClick={() => setIsOpen(false)} style={styles.closeBtn}>✕</button>
//         </div>

//         <div style={styles.chatWindow}>
//           {messages.map((msg, i) => (
//             <div key={i} style={{ ...styles.msgRow, justifyContent: msg.role === "user" ? "flex-end" : "flex-start" }}>
//               <div style={{
//                 ...styles.bubble,
//                 backgroundColor: msg.role === "user" ? "#bca24c" : "#f0f0f0",
//                 color: msg.role === "user" ? "#fff" : "#333",
//                 borderRadius: msg.role === "user" ? "18px 18px 4px 18px" : "18px 18px 18px 4px"
//               }}>
//                 {msg.text}
//               </div>
//             </div>
//           ))}
//           {loading && (
//             <div style={styles.loader}>
//               <span style={styles.dot} />
//               <span style={{ ...styles.dot, animationDelay: "0.2s" }} />
//               <span style={{ ...styles.dot, animationDelay: "0.4s" }} />
//             </div>
//           )}
//           <div ref={chatEndRef} />
//         </div>

//         <div style={styles.inputArea}>
//           <input
//             style={styles.input}
//             value={input}
//             onChange={e => setInput(e.target.value)}
//             onKeyDown={e => e.key === "Enter" && handleSend()}
//             placeholder="Ask me something..."
//           />
//           <button onClick={handleSend} style={styles.sendBtn} disabled={loading}>➤</button>
//         </div>
//       </div>

//       <button
//         onClick={() => { setIsOpen(prev => !prev); setHasNewMessage(false); }}
//         style={styles.toggleBtn}
//       >
//         {isOpen ? "✕" : "✨"}
//         {hasNewMessage && !isOpen && <span style={styles.badge} />}
//       </button>

//       <style>{`
//         @keyframes bounce {
//           0%, 80%, 100% { transform: translateY(0); }
//           40% { transform: translateY(-6px); }
//         }
//         @keyframes pulse {
//           0%, 100% { transform: scale(1); }
//           50% { transform: scale(1.15); }
//         }
//       `}</style>
//     </>
//   );
// }

// const styles = {
//   container: { position: "fixed", bottom: "80px", right: "20px", width: "min(320px, calc(100vw - 40px))", height: "min(450px, calc(100vh - 120px))", background: "#fff", borderRadius: "16px", boxShadow: "0 8px 32px rgba(0,0,0,0.18)", display: "flex", flexDirection: "column", zIndex: 1000, overflow: "hidden" },
//   header: { padding: "14px 16px", background: "#1e1e1e", color: "#bca24c", fontWeight: "bold", fontSize: "0.95rem", display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 },
//   closeBtn: { background: "none", border: "none", color: "#bca24c", cursor: "pointer", fontSize: "1rem", padding: "2px 6px", borderRadius: "4px", lineHeight: 1 },
//   chatWindow: { flex: 1, padding: "12px", overflowY: "auto", display: "flex", flexDirection: "column", gap: "8px" },
//   msgRow: { display: "flex" },
//   bubble: { maxWidth: "80%", padding: "9px 13px", fontSize: "0.85rem", lineHeight: "1.45" },
//   inputArea: { padding: "10px 12px", display: "flex", gap: "8px", borderTop: "1px solid #eee", flexShrink: 0 },
//   input: { flex: 1, padding: "9px 14px", borderRadius: "20px", border: "1px solid #ddd", outline: "none", fontSize: "0.85rem", minWidth: 0 },
//   sendBtn: { background: "#bca24c", border: "none", color: "#fff", cursor: "pointer", fontSize: "1rem", width: "36px", height: "36px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
//   loader: { display: "flex", gap: "4px", padding: "4px 8px", alignItems: "center" },
//   dot: { width: "7px", height: "7px", borderRadius: "50%", background: "#bca24c", display: "inline-block", animation: "bounce 1.2s infinite ease-in-out" },
//   toggleBtn: { position: "fixed", bottom: "20px", right: "20px", width: "52px", height: "52px", borderRadius: "50%", background: "#bca24c", border: "none", color: "#fff", fontSize: "1.4rem", cursor: "pointer", boxShadow: "0 4px 16px rgba(188,162,76,0.45)", zIndex: 1001, display: "flex", alignItems: "center", justifyContent: "center", animation: "pulse 3s infinite ease-in-out" },
//   badge: { position: "absolute", top: "4px", right: "4px", width: "10px", height: "10px", borderRadius: "50%", background: "#e74c3c", border: "2px solid #fff" }
// };























import React, { useState, useRef, useEffect } from "react";
import { db } from "../firebase/firebase";
import { collection, addDoc, query, where, getDocs } from "firebase/firestore";
import config from "../config/app.js";

export default function AIAssistant() {
  const [isOpen, setIsOpen] = useState(false);
  const [hasNewMessage, setHasNewMessage] = useState(false);

  const [messages, setMessages] = useState([
    { role: "model", text: "Hello! I'm ManieraAI. How can I help you today?" }
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [awaitingUserInfo, setAwaitingUserInfo] = useState(false);
  const [pendingBooking, setPendingBooking] = useState(null);
  const [lastMessageTime, setLastMessageTime] = useState(0);

  const chatEndRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
      setHasNewMessage(false);
    }
  }, [messages, isOpen]);

  const addMessage = (role, text) => {
    setMessages(prev => [...prev, { role, text }]);
    if (role === "model" && !isOpen) {
      setHasNewMessage(true);
    }
  };

  // ---- Free, local replies for common small talk (saves API tokens) ----
  const tryLocalReply = (text) => {
    const t = text.toLowerCase().trim();

    const greetings = ["hi", "hello", "hey", "good morning", "good afternoon", "good evening"];
    const thanks = ["thanks", "thank you", "thx", "ty"];
    const byes = ["bye", "goodbye", "see you", "cya"];

    if (greetings.some(g => t === g || t.startsWith(g + " "))) {
      return "Hey there! Want to book an appointment, or ask me something?";
    }
    if (thanks.some(g => t.includes(g))) {
      return "You're welcome! Let me know if you need anything else.";
    }
    if (byes.some(g => t.includes(g))) {
      return "Take care! See you soon 👋";
    }

    const prices = ["price", "cost", "how much"];
    const hours = ["hours", "open", "opening", "when are you open"];

    if (prices.some(p => t.includes(p))) {
      return "Our haircut prices depend on the service. Please choose a haircut type and we will help you.";
    }
    if (hours.some(h => t.includes(h))) {
      return "We are open Monday to Saturday from 09:00 to 20:00.";
    }

    return null;
  };

  const askAI = async (userText) => {
    try {
      const res = await fetch(`${config.apiUrl}/api/chat`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: userText, language: "en" })
      });
      const data = await res.json();
      return data.reply || "I don't have an answer for that 😕";
    } catch (err) {
      console.error("Frontend AI error:", err);
      return "I don't have an answer for that 😕";
    }
  };

  // Simple edit-distance check so we don't have to hardcode every typo
  const levenshtein = (a, b) => {
    const m = a.length, n = b.length;
    const dp = Array.from({ length: m + 1 }, () => new Array(n + 1).fill(0));
    for (let i = 0; i <= m; i++) dp[i][0] = i;
    for (let j = 0; j <= n; j++) dp[0][j] = j;
    for (let i = 1; i <= m; i++) {
      for (let j = 1; j <= n; j++) {
        dp[i][j] = a[i - 1] === b[j - 1]
          ? dp[i - 1][j - 1]
          : 1 + Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]);
      }
    }
    return dp[m][n];
  };

  const detectBookingIntent = (text) => {
    const t = text.toLowerCase();

    // Exact/substring matches for the common phrasings
    if (
      t.includes("appointment") ||
      t.includes("appointments") ||
      t.includes("appoint") ||
      t.includes("apointment") ||
      t.includes("book") ||
      t.includes("reservation") ||
      t.includes("schedule")
    ) {
      return true;
    }

    // Fuzzy fallback: catch typos like "apountment", "apoinment", "aponitment"
    // by comparing each word to "appointment" with a small edit-distance budget.
    const words = t.replace(/[^a-z\s]/g, "").split(/\s+/).filter(Boolean);
    return words.some(w => w.length >= 6 && levenshtein(w, "appointment") <= 3);
  };

  // ---- Date parsing, now tolerant of common typos ----
  const extractDate = (text) => {
    const t = text.toLowerCase();

    const tomorrowVariants = ["tomorrow", "tommorow", "tomorow", "tmr", "tmrw"];
    const todayVariants = ["today", "2day"];

    if (tomorrowVariants.some(v => t.includes(v))) {
      const d = new Date();
      d.setDate(d.getDate() + 1);
      return d.toISOString().split("T")[0];
    }
    if (todayVariants.some(v => t.includes(v))) {
      return new Date().toISOString().split("T")[0];
    }

    const isoMatch = t.match(/\b\d{4}-\d{2}-\d{2}\b/);
    if (isoMatch) return isoMatch[0];

    return null;
  };

  // ---- Time parsing: accepts "13:00", "13 : 00", "13 00", "1pm" etc ----
  // Returns { hour, minute } for ANY recognizable time, even outside business hours.
  const parseTimeAttempt = (text) => {
    const t = text.toLowerCase();

    let match = t.match(/\b(\d{1,2})\s*[:\s]\s*(\d{2})\b/);
    if (match) {
      return { hour: Number(match[1]), minute: Number(match[2]) };
    }

    match = t.match(/\b(\d{1,2})\s*(am|pm)\b/);
    if (match) {
      let hour = Number(match[1]);
      const period = match[2];
      if (period === "pm" && hour < 12) hour += 12;
      if (period === "am" && hour === 12) hour = 0;
      return { hour, minute: 0 };
    }

    return null;
  };

  // Returns a valid "HH:MM" slot string only if it's within business hours
  // (09:00–20:00) and on a real 15-minute increment. Otherwise null.
  const extractTime = (text) => {
    const attempt = parseTimeAttempt(text);
    if (!attempt) return null;

    const { hour, minute } = attempt;
    if (hour >= 9 && hour <= 20 && [0, 15, 30, 45].includes(minute)) {
      return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
    }
    return null;
  };

  const parseFullBooking = (text) => {
    const t = text.toLowerCase();
    let service = null;
    if (t.includes("classic")) service = "Classic Cut";
    if (t.includes("fade")) service = "Fade";
    if (t.includes("taper")) service = "Taper";
    if (t.includes("beard")) service = "Beard Trim";

    const date = extractDate(t);
    const time = extractTime(t);
    const phoneMatch = t.match(/06\d+/);
    const phone = phoneMatch ? phoneMatch[0] : null;
    const nameMatch = text.match(/,\s*([A-Za-z]+)/);
    const name = nameMatch ? nameMatch[1] : null;

    if (service && date && time && name && phone) {
      return { service, date, time, name, phone };
    }
    return null;
  };

  // ---- Parse the "Name, phone, haircut" reply once a slot is confirmed ----
  const parseUserInfoLine = (text) => {
    const parts = text.split(",").map(p => p.trim());
    if (parts.length < 3) return null;

    const [name, phone, haircut] = parts;
    if (!name || !phone || !haircut) return null;

    const phoneValid = /^06\d{7,8}$/.test(phone);
    if (!phoneValid) return null;

    const validHaircuts = ["classic cut", "fade", "taper", "beard trim"];
    const valid = validHaircuts.some(h => haircut.toLowerCase().includes(h));
    if (!valid) return null;

    return { name, phone, haircut };
  };

  const findNextAvailableSlot = async (date) => {
    const hours = Array.from({ length: 12 }, (_, i) => i + 9); // 09..20
    const minutes = ["00", "15", "30", "45"];
    const snap = await getDocs(query(collection(db, "appointments"), where("date", "==", date)));
    const booked = snap.docs.map(doc => doc.data().time);
    for (let h of hours) {
      for (let m of minutes) {
        const time = `${h < 10 ? "0" + h : h}:${m}`;
        if (!booked.includes(time)) return time;
      }
    }
    return null;
  };

  const handleSend = async () => {
    if (!input.trim() || loading) return;
    const now = Date.now();
    if (now - lastMessageTime < 1500) {
      addMessage("model", "Please wait a moment before sending another message.");
      return;
    }
    setLastMessageTime(now);
    addMessage("user", input);
    const userText = input;
    setInput("");
    setLoading(true);

    try {
      // 0. Free local replies for small talk — never touches the AI/Firestore
      const localReply = tryLocalReply(userText);
      if (localReply) {
        addMessage("model", localReply);
        setLoading(false);
        return;
      }

      // 1. Try to parse a full booking in one message
      const fullBooking = parseFullBooking(userText);
      if (fullBooking) {
        const snap = await getDocs(query(collection(db, "appointments"), where("date", "==", fullBooking.date)));
        const booked = snap.docs.map(doc => doc.data().time);
        if (booked.includes(fullBooking.time)) {
          addMessage("model", "Sorry, that time slot is already booked.");
        } else {
          await addDoc(collection(db, "appointments"), {
            date: fullBooking.date,
            time: fullBooking.time,
            name: fullBooking.name,
            phone: fullBooking.phone,
            haircut: fullBooking.service
          });
          addMessage(
            "model",
            `Great, ${fullBooking.name}! Your appointment is confirmed for ${fullBooking.date} at ${fullBooking.time} for ${fullBooking.service}.`
          );
        }
        setLoading(false);
        return;
      }

      // 2. User is mid-flow (a slot was offered, waiting on details)
      if (awaitingUserInfo && pendingBooking) {
        // 2a. Let the user change the offered time before sending details
        const requestedTime = extractTime(userText);
        if (requestedTime) {
          const snap = await getDocs(
            query(collection(db, "appointments"), where("date", "==", pendingBooking.date))
          );
          const booked = snap.docs.map(doc => doc.data().time);

          if (booked.includes(requestedTime)) {
            addMessage("model", `Sorry, ${requestedTime} is already booked. Please choose another time.`);
            setLoading(false);
            return;
          }

          const updatedBooking = { ...pendingBooking, time: requestedTime };
          setPendingBooking(updatedBooking);

          addMessage(
            "model",
            `${requestedTime} is available! Now send your details:\nName, 06xxxxxxxx, haircut (Classic Cut / Fade / Taper / Beard Trim)`
          );
          setLoading(false);
          return;
        }

        // 2a-ii. They tried to specify a time, but it's outside business hours
        // (e.g. "20:00") — tell them that directly instead of the generic
        // "couldn't read that" error, which would be misleading here.
        const timeAttempt = parseTimeAttempt(userText);
        if (timeAttempt) {
          addMessage(
            "model",
            "We're open 09:00–20:00 (15-minute slots). Please pick a time in that window."
          );
          setLoading(false);
          return;
        }

        // 2b. Otherwise expect Name, phone, haircut
        if (!pendingBooking.time) {
          addMessage("model", "What time would you like instead? We're open 09:00–20:00.");
          setLoading(false);
          return;
        }

        const parsed = parseUserInfoLine(userText);
        if (!parsed) {
          addMessage(
            "model",
            "Couldn't read that — please send your details as: Name, 06xxxxxxxx, haircut (Classic Cut / Fade / Taper / Beard Trim)"
          );
          setLoading(false);
          return;
        }

        // Re-check availability right before writing — someone else could have
        // booked this exact slot in the meantime.
        const recheckSnap = await getDocs(
          query(
            collection(db, "appointments"),
            where("date", "==", pendingBooking.date),
            where("time", "==", pendingBooking.time)
          )
        );
        if (!recheckSnap.empty) {
          addMessage(
            "model",
            `Sorry, ${pendingBooking.time} on ${pendingBooking.date} was just booked by someone else. Please pick another time.`
          );
          setPendingBooking(null);
          setAwaitingUserInfo(false);
          setLoading(false);
          return;
        }

        await addDoc(collection(db, "appointments"), {
          date: pendingBooking.date,
          time: pendingBooking.time,
          name: parsed.name,
          phone: parsed.phone,
          haircut: parsed.haircut
        });
        addMessage(
          "model",
          `✅ Booked! Your appointment on ${pendingBooking.date} at ${pendingBooking.time} for ${parsed.haircut} is confirmed.`
        );
        setPendingBooking(null);
        setAwaitingUserInfo(false);
        setLoading(false);
        return;
      }

      // 3. Booking intent without full details yet
      const wantsBooking = detectBookingIntent(userText);
      const date = extractDate(userText);

      if (wantsBooking || date) {
        if (!date) {
          addMessage("model", "Sure! What day works for you? You can say today, tomorrow, or a date like 2026-06-20.");
          setLoading(false);
          return;
        }

        // If they already named a time in this message, honor it if possible,
        // or explain why not, instead of silently offering the first slot.
        const requestedTime = extractTime(userText);
        const timeAttempt = parseTimeAttempt(userText);

        if (!requestedTime && timeAttempt) {
          addMessage(
            "model",
            "We're open 09:00–20:00 (15-minute slots). Please pick a time in that window."
          );
          setLoading(false);
          return;
        }

        if (requestedTime) {
          const snap = await getDocs(query(collection(db, "appointments"), where("date", "==", date)));
          const booked = snap.docs.map(doc => doc.data().time);
          if (booked.includes(requestedTime)) {
            addMessage("model", `Sorry, ${requestedTime} on ${date} is already booked. Would you like another time?`);
            setPendingBooking({ date, time: null });
            setAwaitingUserInfo(true);
            setLoading(false);
            return;
          }
          addMessage(
            "model",
            `${requestedTime} on ${date} is available! Send your details:\nName, 06xxxxxxxx, haircut (Classic Cut / Fade / Taper / Beard Trim)`
          );
          setPendingBooking({ date, time: requestedTime });
          setAwaitingUserInfo(true);
          setLoading(false);
          return;
        }

        const slot = await findNextAvailableSlot(date);
        if (!slot) {
          addMessage("model", `Sorry, there are no open slots for ${date}.`);
        } else {
          addMessage(
            "model",
            `The first open slot on ${date} is at ${slot}. If you want another time, just tell me. Otherwise send your details:\nName, 06xxxxxxxx, haircut (Classic Cut / Fade / Taper / Beard Trim)`
          );
          setPendingBooking({ date, time: slot });
          setAwaitingUserInfo(true);
        }
        setLoading(false);
        return;
      }

      // 4. Only reach the AI for genuinely open-ended questions
      const reply = await askAI(userText);
      addMessage("model", reply);

    } catch (err) {
      console.error(err);
      addMessage("model", "Something went wrong processing that message.");
    }

    setLoading(false);
  };

  return (
    <>
      <div style={{
        ...styles.container,
        opacity: isOpen ? 1 : 0,
        pointerEvents: isOpen ? "all" : "none",
        transform: isOpen ? "translateY(0) scale(1)" : "translateY(20px) scale(0.95)",
        transition: "all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1)"
      }}>
        <div style={styles.header}>
          <span>✨ ManieraAI</span>
          <button onClick={() => setIsOpen(false)} style={styles.closeBtn}>✕</button>
        </div>

        <div style={styles.chatWindow}>
          {messages.map((msg, i) => (
            <div key={i} style={{ ...styles.msgRow, justifyContent: msg.role === "user" ? "flex-end" : "flex-start" }}>
              <div style={{
                ...styles.bubble,
                backgroundColor: msg.role === "user" ? "#bca24c" : "#f0f0f0",
                color: msg.role === "user" ? "#fff" : "#333",
                borderRadius: msg.role === "user" ? "18px 18px 4px 18px" : "18px 18px 18px 4px"
              }}>
                {msg.text}
              </div>
            </div>
          ))}
          {loading && (
            <div style={styles.loader}>
              <span style={styles.dot} />
              <span style={{ ...styles.dot, animationDelay: "0.2s" }} />
              <span style={{ ...styles.dot, animationDelay: "0.4s" }} />
            </div>
          )}
          <div ref={chatEndRef} />
        </div>

        <div style={styles.inputArea}>
          <input
            style={styles.input}
            value={input}
            onChange={e => setInput(e.target.value)}
            onKeyDown={e => e.key === "Enter" && handleSend()}
            placeholder="Ask me something..."
          />
          <button onClick={handleSend} style={styles.sendBtn} disabled={loading}>➤</button>
        </div>
      </div>

      <button
        onClick={() => { setIsOpen(prev => !prev); setHasNewMessage(false); }}
        style={styles.toggleBtn}
      >
        {isOpen ? "✕" : "✨"}
        {hasNewMessage && !isOpen && <span style={styles.badge} />}
      </button>

      <style>{`
        @keyframes bounce {
          0%, 80%, 100% { transform: translateY(0); }
          40% { transform: translateY(-6px); }
        }
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.15); }
        }
      `}</style>
    </>
  );
}

const styles = {
  container: { position: "fixed", bottom: "80px", right: "20px", width: "min(320px, calc(100vw - 40px))", height: "min(450px, calc(100vh - 120px))", background: "#fff", borderRadius: "16px", boxShadow: "0 8px 32px rgba(0,0,0,0.18)", display: "flex", flexDirection: "column", zIndex: 1000, overflow: "hidden" },
  header: { padding: "14px 16px", background: "#1e1e1e", color: "#bca24c", fontWeight: "bold", fontSize: "0.95rem", display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 },
  closeBtn: { background: "none", border: "none", color: "#bca24c", cursor: "pointer", fontSize: "1rem", padding: "2px 6px", borderRadius: "4px", lineHeight: 1 },
  chatWindow: { flex: 1, padding: "12px", overflowY: "auto", display: "flex", flexDirection: "column", gap: "8px" },
  msgRow: { display: "flex" },
  bubble: { maxWidth: "80%", padding: "9px 13px", fontSize: "0.85rem", lineHeight: "1.45" },
  inputArea: { padding: "10px 12px", display: "flex", gap: "8px", borderTop: "1px solid #eee", flexShrink: 0 },
  input: { flex: 1, padding: "9px 14px", borderRadius: "20px", border: "1px solid #ddd", outline: "none", fontSize: "0.85rem", minWidth: 0 },
  sendBtn: { background: "#bca24c", border: "none", color: "#fff", cursor: "pointer", fontSize: "1rem", width: "36px", height: "36px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
  loader: { display: "flex", gap: "4px", padding: "4px 8px", alignItems: "center" },
  dot: { width: "7px", height: "7px", borderRadius: "50%", background: "#bca24c", display: "inline-block", animation: "bounce 1.2s infinite ease-in-out" },
  toggleBtn: { position: "fixed", bottom: "20px", right: "20px", width: "52px", height: "52px", borderRadius: "50%", background: "#bca24c", border: "none", color: "#fff", fontSize: "1.4rem", cursor: "pointer", boxShadow: "0 4px 16px rgba(188,162,76,0.45)", zIndex: 1001, display: "flex", alignItems: "center", justifyContent: "center", animation: "pulse 3s infinite ease-in-out" },
  badge: { position: "absolute", top: "4px", right: "4px", width: "10px", height: "10px", borderRadius: "50%", background: "#e74c3c", border: "2px solid #fff" }
};